export default function initSlick() {
    $('.js-carousel-mob').slick({
        mobileFirst: true,
        infinite: false,
        dots: true,
        arrows: false,
        variableWidth: false,
        slidesToShow: 1,
        slidesToScroll: 1,

        responsive: [
            {
                breakpoint: 480,
                settings: "unslick"
            }
        ]
    });
}

$('.longevity-product__slider-top').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.longevity-product__slider-bottom'
});

$('.longevity-product__slider-bottom').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    asNavFor: '.longevity-product__slider-top',
    dots: false,
    focusOnSelect: true
});

$('.js-hero-slider').slick({
    slidesToShow: 1,
    arrows: false,
    fade: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
});

// On before slide change
$('.js-hero-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $(this).find(`[data-slick-index="${currentSlide}"] .s-hero__col-text`).removeClass('aos-animate');
    $(this).find(`[data-slick-index="${nextSlide}"] .s-hero__col-text`).removeClass('aos-animate');
});

// On after slide change
$('.js-hero-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    $(this).find(`[data-slick-index="${currentSlide}"] .s-hero__col-text`).addClass('aos-animate');
});
